import { useNavigate } from 'react-router-dom';
import GradientBorder from './GradientBorder';
import greyMonkey from '../assets/greenpill/greyMonkey.png';
import Modal from './Modal';
import MintNFTModal from '../features/greenpill/MintNFTModal';

const EmptyArray = () => {
    return (
        <div className="flex w-full bg-[#EEF4EF] relative items-center justify-center">
            <div className="relative w-full flex items-center justify-center">
                <img className="w-72 " src={greyMonkey} alt="Onboarding GIF" />

                <Modal>
                    <Modal.Button opens={'mint'}>
                        <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-full ">
                            <p className="text-center  cursor-pointer text-tPrimary">What are you waiting for?</p>
                            <p className="text-center  cursor-pointer text-tPrimary">
                                Take action and mint a Greenpill now! →
                            </p>
                        </div>
                    </Modal.Button>
                    <Modal.Window name={'mint'}>
                        <MintNFTModal />
                    </Modal.Window>
                </Modal>
            </div>
        </div>
    );
};

export default EmptyArray;
